(function() {
  'use strict';

  var script = document.currentScript;
  var languageCode = script
    ? script.getAttribute('data-language-code')
    : '';

  if (String(languageCode || '').toLowerCase() !== 'en') {
    return;
  }

  var optionTextSelector = [
    '.selector-wrapper > label',
    '.favorites-section__option > span',
    '.cart-drawer__saved-option > span',
    '.cart-drawer__item-options > p'
  ].join(', ');
  var optionAriaSelector = [
    '.selector-wrapper [aria-label]',
    '.favorites-section__option [aria-label]',
    '.cart-drawer__saved-option [aria-label]',
    '.cart-drawer__item-options [aria-label]'
  ].join(', ');

  function translateOptionName(value) {
    return String(value || '')
      .replace(
        /(^|\s)色(?=\s*[：:]|\s*$)/g,
        '$1Color'
      )
      .replace(
        /(^|\s)サイズ(?=\s*[：:]|\s*$)/g,
        '$1Size'
      );
  }

  function translateText(element) {
    var translated = translateOptionName(element.textContent);

    if (translated !== element.textContent) {
      element.textContent = translated;
    }
  }

  function translateAriaLabel(element) {
    var current = element.getAttribute('aria-label');
    var translated = translateOptionName(current);

    if (translated !== current) {
      element.setAttribute('aria-label', translated);
    }
  }

  function translatePolicyTitle() {
    var path = window.location.pathname.replace(/\/$/, '');
    var policyMatch = path.match(/\/policies\/([^/]+)$/);
    var policyHeadings = {
      'terms-of-service': 'Terms of Service',
      'privacy-policy': 'Privacy Policy',
      'refund-policy': 'Refund Policy',
      'legal-notice': 'Legal Notice',
      'shipping-policy': 'Shipping'
    };
    var title;

    if (!policyMatch || !policyHeadings[policyMatch[1]]) {
      return;
    }

    title = document.querySelector('.shopify-policy__title h1');

    if (title) {
      title.textContent = policyHeadings[policyMatch[1]];
    }
  }

  function processRoot(root) {
    var textElements;
    var ariaElements;

    if (!root || root.nodeType !== 1) {
      return;
    }

    if (root.matches && root.matches(optionTextSelector)) {
      translateText(root);
    }

    if (root.matches && root.matches(optionAriaSelector)) {
      translateAriaLabel(root);
    }

    textElements = root.querySelectorAll(optionTextSelector);
    ariaElements = root.querySelectorAll(optionAriaSelector);

    Array.prototype.forEach.call(textElements, translateText);
    Array.prototype.forEach.call(ariaElements, translateAriaLabel);
  }

  function start() {
    translatePolicyTitle();
    processRoot(document.body);

    if (!document.body || typeof window.MutationObserver !== 'function') {
      return;
    }

    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        Array.prototype.forEach.call(
          mutation.addedNodes,
          processRoot
        );
      });
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
